import React from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, Box, Text, VStack, HStack, Flex,
} from '@chakra-ui/react';
import { FiBook, FiArrowUpCircle, FiArrowDownCircle, FiCheckCircle } from 'react-icons/fi';

export default function BookKeeperEntryModal({ isOpen, onClose, onOpen }) {
  const handleLedger     = () => { onClose(); onOpen('ledger'); };
  const handleRaise      = () => { onClose(); onOpen('raise'); };
  const handleAssign     = () => { onClose(); onOpen('assign'); };
  const handlePay        = () => { onClose(); onOpen('pay'); };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay bg="blackAlpha.500" />
      <ModalContent>
        <ModalHeader fontSize="lg" fontWeight="800" textAlign="center" pb={0}>
          📒 Bookkeeper
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pt={4} pb={6}>
          <VStack spacing={3}>
            <Text fontSize="11px" color="gray.500" textAlign="center">
              What would you like to do?
            </Text>

            {/* Ledger */}
            <Box
              as="button" w="100%" p={5} borderRadius="xl"
              border="2px solid" borderColor="blue.200"
              bg="blue.50" _hover={{ bg: 'blue.100', borderColor: 'blue.400' }}
              cursor="pointer" transition="all 0.15s"
              onClick={handleLedger}
            >
              <Flex align="center" gap={4}>
                <Box color="blue.500"><FiBook size={32} /></Box>
                <Box textAlign="left">
                  <Text fontSize="16px" fontWeight="800" color="blue.700">Ledger</Text>
                  <Text fontSize="11px" color="gray.500">View all invoices, payments and full financial history</Text>
                </Box>
              </Flex>
            </Box>

            {/* Raise Invoices */}
            <Box
              as="button" w="100%" p={5} borderRadius="xl"
              border="2px solid" borderColor="green.200"
              bg="green.50" _hover={{ bg: 'green.100', borderColor: 'green.400' }}
              cursor="pointer" transition="all 0.15s"
              onClick={handleRaise}
            >
              <Flex align="center" gap={4}>
                <Box color="green.500"><FiArrowUpCircle size={32} /></Box>
                <Box textAlign="left">
                  <Text fontSize="16px" fontWeight="800" color="green.700">Raise Invoices</Text>
                  <Text fontSize="11px" color="gray.500">Money IN — invoices sent to clients, track payments received</Text>
                </Box>
              </Flex>
            </Box>

            {/* Assign Received Money */}
            <Box
              as="button" w="100%" p={5} borderRadius="xl"
              border="2px solid" borderColor="teal.200"
              bg="teal.50" _hover={{ bg: 'teal.100', borderColor: 'teal.400' }}
              cursor="pointer" transition="all 0.15s"
              onClick={handleAssign}
            >
              <Flex align="center" gap={4}>
                <Box color="teal.500"><FiCheckCircle size={32} /></Box>
                <Box textAlign="left">
                  <Text fontSize="16px" fontWeight="800" color="teal.700">Assign Received Money</Text>
                  <Text fontSize="11px" color="gray.500">Match money received to client accounts and open invoices awaiting payment</Text>
                </Box>
              </Flex>
            </Box>

            {/* Pay Invoices */}
            <Box
              as="button" w="100%" p={5} borderRadius="xl"
              border="2px solid" borderColor="red.200"
              bg="red.50" _hover={{ bg: 'red.100', borderColor: 'red.400' }}
              cursor="pointer" transition="all 0.15s"
              onClick={handlePay}
            >
              <Flex align="center" gap={4}>
                <Box color="red.500"><FiArrowDownCircle size={32} /></Box>
                <Box textAlign="left">
                  <Text fontSize="16px" fontWeight="800" color="red.700">Pay Invoices</Text>
                  <Text fontSize="11px" color="gray.500">Money OUT — supplier invoices received, amounts to pay</Text>
                </Box>
              </Flex>
            </Box>
          </VStack>
        </ModalBody>
        <ModalFooter pt={0}>
          <Button size="sm" variant="ghost" onClick={onClose} w="100%">Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
